/**
 * 全局配置
 */
// const host = 'http://xiangcunrc.hntvhbygh.com' // 测试域名
const host = 'https://www.xcrck.com' // 正式域名
export const BASE_URL = `${host}`                    // 基础路径
export const API_BASE_URL = `${host}/api`            // 接口请求基础路径
export const UPLOAD_IMAGE_URL = `${host}/api/v1/5fc615f7da92b` // 图片上传接口路径 UploadImage方法依赖此配置
